import { AccountBasic } from '~hooks/useAccount/models';
import UserStore from '~store/UserStore';

export function getEffectiveUserCompanyId(userStore: UserStore): string {
  const companyId = userStore.currentCompanies?.[0]?.id ?? userStore.userCompany.id;

  return companyId;
}

export function getEffectiveUserCompany(userStore: UserStore) {
  const company = userStore.currentCompanies?.[0] ?? userStore.userCompany;

  return company;
}

export function getEffectiveUserCompanyName(userStore: UserStore): string {
  const companyName =
    userStore.currentCompanies?.[0]?.legalName ?? userStore.userCompany.legalName ?? '';

  return companyName;
}

/**
 * Returns true if the effective logged-in company is the customer on the
 * account, i.e. the account's connected company. Accounts without a connected
 * company represent offline customers, which can never be the viewer.
 */
export function isViewerAccountCustomer(
  userStore: UserStore,
  account?: AccountBasic | null,
) {
  const connectedCompanyId = account?.connectedCompany?.id;

  return (
    Boolean(connectedCompanyId) &&
    connectedCompanyId === getEffectiveUserCompanyId(userStore)
  );
}
